'use strict'

const CREW_COLORS = [
  '#1f5e3a', '#c66a45', '#3454c1', '#b35d1a',
  '#6e3fb7', '#2f7a3e', '#a9341d', '#107a7a'
]

export function getCrewColor (crewId, crewIds) {
  const index = crewIds.indexOf(crewId)
  if (index < 0) return '#9E9E9E'
  return CREW_COLORS[index % CREW_COLORS.length]
}

export function getRouteColor (routeId, routeIds) {
  const index = (routeIds || []).indexOf(routeId)
  if (index < 0) return '#9E9E9E'
  return CREW_COLORS[index % CREW_COLORS.length]
}

export default CREW_COLORS
